"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
// const MERGE_TAGS = [
//   '<osys:date format="" />',
//   '<osys:context name="" />',
//   '<osys:context />',
// ];
exports.mergeTags = (html) => {
    const now = moment_1.default();
    html = html.replace(new RegExp('<currentday>', 'gm'), now.format('D'));
    html = html.replace(new RegExp('<currentdayname>', 'gm'), now.format('dddd'));
    html = html.replace(new RegExp('<currentmonth>', 'gm'), now.format('M'));
    html = html.replace(new RegExp('<currentmonthname>', 'gm'), now.format('MMMM'));
    html = html.replace(new RegExp('<currentyear>', 'gm'), now.format('Y'));
    return html;
};
//# sourceMappingURL=mergeTags.js.map